import insertNewBlock from './insertNewBlock';

var insertEmptyBlock = function insertEmptyBlock(editorState) {
  var blockType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unstyled';

  return insertNewBlock(editorState, blockType);
};

export default insertEmptyBlock;


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-modifiers/es/insertEmptyBlock.js
// module id = 244
// module chunks = 0